



























































































import Vue from "vue";
import Gumshoe from "gumshoejs";
// import SmoothScroll from "smooth-scroll";
import * as smoothScroll from "./../../assets/js/smooth-scroll.min.js";
import { resturant } from "@/mocks/client.js";
export default Vue.extend({
  props: {
    resturant: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data() {
    return {
      spy: null,
      scroll: null,
      activeElement: null,
      // items: resturant,
      showTop: false,
      showedItems: 7,
      showDropdown: false,
      mobileSelector: ".inner-nav.nav--2 a",
      desktopSelector: ".inner-nav a",
      isMobile: null
    };
  },
  methods: {
    update() {
      this.isMobile = Boolean(window.innerWidth < 992);
      const resturantHeader = this.$refs.resturant as HTMLElement;
      const height = resturantHeader.clientHeight;
      const top = resturantHeader.getBoundingClientRect().top;
      if (this.isMobile) {
        this.showTop = window.scrollY > 225 ? true : false;
      }
      if (window.scrollY > height + top + 300) {
        this.showTop = true;
      } else {
        this.showTop = false;
      }
    },
    gumShoe(event: any) {
      if (this.isMobile) {
        event.target.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest"
        });
      }
      const link = event.detail.link;
      const activeIndex = link.dataset.index;
      if (activeIndex >= this.showedItems) {
        // this.showDropdown = true;
        this.activeElement = this.resturant.Categories[activeIndex].name;
      } else {
        // this.showDropdown = false;
        this.activeElement = null;
      }
    },
    initSpyScroll(isMobile: boolean) {
      if (this.spy) {
        document.removeEventListener("gumshoeActivate", this.gumShoe, false);
        this.spy.destroy();
      }
      const selector = isMobile ? this.mobileSelector : this.desktopSelector;
      this.$nextTick(() => {
        this.spy = new Gumshoe(selector, {
          offset: () => {
            return !this.showTop ? 550 : 250;
          },
          navClass: "active", // applied to the nav list item
          nested: false,
          contentClass: "active", // applied to the content
          reflow: true, // if true, listen for reflows
          // nested: true,
          // Event support
          events: true // if true, emit custom events
        });

        // Listen for activate events
        document.addEventListener("gumshoeActivate", this.gumShoe, false);
      });
    }
  },
  watch: {
    showTop() {
      this.spy.detect();
    },
    isMobile() {
      this.initSpyScroll(this.isMobile);
    }
  },
  mounted() {
    this.isMobile = Boolean(window.innerWidth < 992);
    window.addEventListener("scroll", this.update);
    window.addEventListener("resize", this.update);
    this.$nextTick(() => {
      smoothScroll.init({
        offset: 150
      });
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.update);
    window.removeEventListener("resize", this.update);
    this.spy.destroy();
    smoothScroll.destroy();
  }
});
